import { Typography } from "@material-ui/core";
import React from "react";
import { CreditCard, RewardsAccount } from "redmond";
import { isCaponeTenant } from "@capone/common";
import { paymentTextConstants } from "halifax";
import { config } from "../../../../api/config";

export const PC_PAYMENT_TYPES_ELIGIBILITY_BANNER_TEXT = (
  rewardsAccounts: RewardsAccount[],
  isAnySpark: boolean,
  paymentMethods: CreditCard[],
  lodgingIsLifestyleCollection?: boolean,
  isLifestyleOnlyCollectionEnabled?: boolean,
  isLifestyleEligible?: boolean | null
) => {
  const pcAllowedProducts = ["Venture X", "Venture X Business"];
  const lcPremiumAllowedProducts = ["Venture X", "Venture X Business"];
  const lcNonPremiumCardholderVariant = isCaponeTenant(config.TENANT)
    ? ["Venture", "Spark Miles"]
    : ["Venture Business", "Spark Miles"];

  const productNameContainsSelectCondition = (rewardsAccount: RewardsAccount) =>
    isCaponeTenant(config.TENANT)
      ? !rewardsAccount.productDisplayName.includes("Select")
      : true;

  const eligibleAccounts = rewardsAccounts.filter((rewardsAccount) => {
    // Special handling for Spark Cash Plus with lifestyle eligibility
    if (
      rewardsAccount.productDisplayName === "Spark Cash Plus" &&
      lodgingIsLifestyleCollection &&
      isLifestyleEligible
    ) {
      return true;
    }

    return lodgingIsLifestyleCollection
      ? lcNonPremiumCardholderVariant.includes(
            rewardsAccount.productDisplayName
          ) &&
          rewardsAccount.productDisplayName !== "VentureOne" &&
          productNameContainsSelectCondition(rewardsAccount)
        || lcPremiumAllowedProducts.includes(rewardsAccount.productDisplayName)
      : pcAllowedProducts.includes(rewardsAccount.productDisplayName);
  });

  if (
    eligibleAccounts.length < rewardsAccounts.length ||
    (isAnySpark && eligibleAccounts.length < paymentMethods.length)
  ) {
    const accountName =
      paymentTextConstants.REWARDS_ACCOUNT_NAMES(eligibleAccounts);
    const isPlural = eligibleAccounts.length > 1;

    // Check if any eligible account is Spark Cash Plus (lifestyle only)
    const hasSparkCashPlusOnly = eligibleAccounts.some(
      account => account.productDisplayName === "Spark Cash Plus"
    );

    const collectionText = (() => {
      switch (true) {
        case isLifestyleOnlyCollectionEnabled:
          return "Lifestyle";
        case hasSparkCashPlusOnly && lodgingIsLifestyleCollection:
          return "Lifestyle";
        case lodgingIsLifestyleCollection:
          return "both Premier and Lifestyle";
        default:
          return "Premier";
      }
    })();

    return (
      <Typography className="label" variant="body2">
        Only your <strong>{accountName}</strong> account
        {isPlural ? "s are" : " is"} eligible for {collectionText} Collection
        bookings.
      </Typography>
    );
  }
  return undefined;
};

export const PAYMENT_PAY_LATER_NOTES =
  "When you pay at the hotel you will be billed in the local currency of the hotel. Rates quoted in USD are an estimate based on current exchange rates. Exchange rates vary and are subject to change.";
export const PAYMENT_STEP_PAY_LATER_SUBTITLE =
  "This card will be used to hold your reservation but won't be charged when booking.";
export const PAYMENT_STEP_PAY_LATER_TITLE = "Step 3: Reserve with Credit Card";
export const PAYMENT_STEP_PAY_LATER_TITLE_MOBILE = "Reserve with Credit Card";
